import {handleActions} from 'redux-actions'
import {updateVerifyingCreds} from './actions'

export const initialState = {
  creds: null,
  needCheck: null
}

export default handleActions(
  {
    [updateVerifyingCreds](state, {payload}) {
      return {
        ...state,
        creds: payload.creds,
        needCheck: payload.needCheck
      }
    }
  },
  initialState
)
